import * as R from "ramda"

export const calendly = "https://calendly.com/dalma-kennenlernen/15-min"

export const CGU = "https://editique.dalma.co/formule_dalma/latest/CGU_dalma_fr.pdf"

export const FIC = "https://editique.dalma.co/formule_dalma/latest/FIC_NI_Dalma_fr.pdf"

export const PRIVACY_POLICY_URL =
  "https://editique.dalma.co/formule_dalma/latest/Dalma-Politique_de_confidentialite.pdf"

export const DIPA = "https://editique.dalma.co/formule_dalma/latest/IPID_Dalma_fr.pdf"

const LEGAL_LINKS = {
  CGU: "https://editique.dalma.co/formule_dalma/latest/RC_CONTRACT_ID/CGU_dalma_fr.pdf",
  FIC: "https://editique.dalma.co/formule_dalma/latest/RC_CONTRACT_ID/FIC_NI_Dalma_fr.pdf",
  PRIVACY_POLICY_URL:
    "https://editique.dalma.co/formule_dalma/latest/RC_CONTRACT_ID/Dalma-Politique_de_confidentialite.pdf",
  DIPA: "https://editique.dalma.co/formule_dalma/latest/RC_CONTRACT_ID/IPID_Dalma_fr.pdf",
  GUARANTEES_TABLE:
    "https://editique.dalma.co/formule_dalma/latest/Tableau_de_garanties_Dalma_fr.pdf",
} as const

export function buildLegalURL(
  rcContractId: string | undefined | null,
  documentType: keyof typeof LEGAL_LINKS
) {
  if (rcContractId) {
    return R.replace("RC_CONTRACT_ID", rcContractId, LEGAL_LINKS[documentType])
  }
  return R.replace("/RC_CONTRACT_ID", "", LEGAL_LINKS[documentType])
}

export const FR_APP_DOWNLOAD_URL = "https://dalma.onelink.me/tYCk/49mk01sk"
